import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Clear({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M8.49996 22V20M15.5 22V20M12 22V20M16.76 22H7.22996C6.11996 22 5.21996 21.1 5.21996 20C5.20996 19.92 5.21996 19.85 5.22996 19.77L5.57996 16.549C5.79996 14.519 7.50996 12.989 9.54996 12.991H14.39C16.42 12.981 18.14 14.521 18.37 16.549L18.72 19.77C18.84 20.86 18.05 21.85 16.95 21.97C16.87 21.97 16.79 21.98 16.72 21.98L16.76 22ZM12 2C12.82 2 13.5 2.67 13.5 3.5V9.5C13.5 9.77 13.27 10 13 10H11C10.72 10 10.5 9.77 10.5 9.5V3.5C10.5 2.67 11.17 2 12 2ZM14.25 13H9.74996C9.18996 13 8.73996 12.55 8.73996 12C8.72996 11.86 8.75996 11.73 8.80996 11.61L9.21996 10.61C9.36996 10.23 9.72996 9.99 10.14 9.99H13.8C14.2 9.98 14.56 10.23 14.72 10.6L15.13 11.6C15.34 12.1 15.1 12.69 14.59 12.9C14.46 12.95 14.33 12.97 14.2 12.97L14.25 13Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Clear;